import { render, staticRenderFns } from "./DetailsTable.vue?vue&type=template&id=40e6789e&scoped=true&"
import script from "./DetailsTable.vue?vue&type=script&lang=js&"
export * from "./DetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTable.vue?vue&type=style&index=0&id=40e6789e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e6789e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e6789e')) {
      api.createRecord('40e6789e', component.options)
    } else {
      api.reload('40e6789e', component.options)
    }
    module.hot.accept("./DetailsTable.vue?vue&type=template&id=40e6789e&scoped=true&", function () {
      api.rerender('40e6789e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/DetailsTable.vue"
export default component.exports